// Central contact details for لمسة احتراف

export const PHONE_E164 = "+966538180411";
export const PHONE_LOCAL = "0538180411";
export const PHONE_TEL_HREF = "tel:+966538180411";
export const WHATSAPP_NUMBER = "966538180411";
export const WHATSAPP_HREF = "https://wa.me/966538180411";

/**
 * Generates a WhatsApp link with an optional prefilled message.
 */
export function whatsappLink(message?: string): string {
  if (!message) {
    return WHATSAPP_HREF;
  }
  return `${WHATSAPP_HREF}?text=${encodeURIComponent(message)}`;
}
